import React, { useMemo, useState, useEffect, useRef } from 'react'
import {
  Button,
  Form,
  Row,
  Col,
  Table
} from '@themesberg/react-bootstrap'
import { motion } from 'framer-motion/dist/framer-motion'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCheckSquare, faEdit, faEye, faWindowClose } from '@fortawesome/free-solid-svg-icons'
import PaginationComponent from '../../../components/Pagination'
import usePromotionListing from './hooks/usePromotionListing'
import Trigger from '../../../components/OverlayTrigger'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import { AdminsRoutes } from '../../../routes'
import useCheckPermission from '../../../utils/checkPermission'
import ConfirmationModal from '../../../components/ConfirmationModal'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
// import Menu from '@mui/material/Menu'
// import MenuItem from '@mui/material/MenuItem'
// import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
// import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
// import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
// import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import ActionMenu from './ActionMenu'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import { AddButtonStyled, ButtonContainer, CustomCol, ResponsiveTitle } from '../CMS/style'
import { HeaderRow, SectionHeaderWrap } from '../../../components/StyledComponents'
import useTableCustom from '../../../components/CusotmFilter'
import { tableColumnHeaders, promotionCategories } from './constants'

import TableErrorMessage from '../../../components/TableErrorMessage'
import ImageModal from "../../../components/ImageModal";


const { REACT_APP_S3_URL } = process.env;


export default () => {
  const {
    page,
    limit,
    setPage,
    setLimit,
    setSearch,
    search,
    setSelectedClient,
    navigate,
    promotionsData,
    totalPages,
    selectedClient,
    selectedPortal,
    setSelectedPortal,
    loading,
    handleStatusShow,
    statusShow,
    setStatusShow,
    handleYes,
    status,
    active,
    setActive,
    name,
    handleDeletePromotions,
    imageModal, setImageModal,
    totalCount
  } = usePromotionListing()

  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");
  const { isHidden } = useCheckPermission()



  const isShowActionColumn = !isHidden({ module: { key: 'Promotions', value: 'U' } }) || !isHidden({ module: { key: 'Promotions', value: 'D' } })

  const dynamicTableHeaders = useMemo(() => {
    const headers = [...tableColumnHeaders.filter(col => col.value !== 'action')];
    if (isShowActionColumn) {
      headers.push({
        accessorKey: 'action',
        Header: 'Actions',
        value: 'action',
        label: 'Actions',
      });
    }

    return headers;
  }, [isShowActionColumn]);

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    promotionsData,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "PROMOTIONS_TABLE"
  );


  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 110;
      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [visibleColumns]);

  return (
    <>
      <div ref={headerRef} className=''>
        <SectionHeaderWrap >
          <HeaderRow>
            <Col xs={12} md={6}>
              <ResponsiveTitle className="title-text">
                Promotions
              </ResponsiveTitle>
            </Col>

            <Col xs={12} md={6}>
              <ButtonContainer className="d-flex justify-content-md-end">
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                  className="flex-grow-1 flex-md-grow-0"
                >
                  <AddButtonStyled
                    variant="primary"
                    onClick={() => navigate(AdminsRoutes.CreatePromotions)}
                    hidden={isHidden({ module: { key: 'Promotions', value: 'C' } })}
                  >
                    <AddCircleOutlineRoundedIcon />
                    <span>Create Promotion</span>
                  </AddButtonStyled>
                </motion.div>
                <div className="ms-auto ms-md-2">
                  <NotificationIconContainer />
                </div>
              </ButtonContainer>
            </Col>
          </HeaderRow>
        </SectionHeaderWrap>
      </div>
      <div className="FormsBg" ref={filterRef}>
        <Row>
          <Col lg={4} md={12} sm={12}>
            <div className="d-flex flex-column flex-md-row justify-content-between gap-2 mb-2 mt-2">
              <Form.Control
                type="search"
                className="custom-col-setting-width"
                value={search}
                placeholder="Search title, slug"
                onChange={(event) =>
                  setSearch(event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ""))
                }
              />


            </div>
          </Col>
          <Col lg={8} md={12} className='mb-2 mt-2' >
            <div style={{ maxWidth: '200px', flexShrink: 0 }}>{customColSetting}</div>
          </Col>
        </Row>
      </div>

      {visibleColumns?.length > 0 ? <div className='TableBg mt-2 pt-1'>

        <Table striped responsive hover size='sm' className='text-center mt-3'>
          <thead className='thead-light'>
            <tr>
              {visibleColumns.map((h) => (
                <th key={h.label}>{h.label}</th>
              ))}
            </tr>
          </thead>



          <tbody id={loading ? 'cover-spin' : ''}>
            {!loading && promotionsData?.length > 0 && promotionsData.map((row, index) => (
              <tr key={row.promotionId}>
                {visibleColumns.map((col, cIdx) => {
                  const key = col.accessorKey;
                  switch (key) {
                    case "promotionId":
                      return <td key={cIdx}>{row.promotionId}</td>;

                    case "category":
                      const categoryLabel =
                        promotionCategories.find((cat) => cat.value === row?.category)
                      return <td key={cIdx}>{categoryLabel?.label || "N/A"}</td>;

                    case "image":
                      return <td key={cIdx}>
                        {row.image ? <img
                          src={`${REACT_APP_S3_URL}/${row.image}`} //}` row.image} // or URL.createObjectURL(row.image) if it's a File object
                          alt={row.categoryImage}
                          style={{ width: '100px', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                          onClick={() => setImageModal({ isOpen: true, url: `${REACT_APP_S3_URL}/${row.image}` })}
                        /> : "N/A"}

                      </td>;

                    case "title":
                      return (
                        <td key={cIdx}>
                          <Trigger message={row.title?.EN}>
                            <span
                              style={{ width: "150px", cursor: "pointer" }}
                              className="text-link d-inline-block text-truncate"
                            >
                              {row.title?.EN}
                            </span>
                          </Trigger>
                        </td>
                      );

                    case "slug":
                      return <td key={cIdx}>{row.slug}</td>;

                    case "status":
                      return (
                        <td key={cIdx}>
                          {row.isActive ? (
                            <span className="text-success">Active</span>
                          ) : (
                            <span className="text-danger">Inactive</span>
                          )}
                        </td>
                      );

                    case "action":
                      return (
                        <td key={cIdx}>
                          <ActionMenu
                            promotionId={row.promotionId}
                            promotionsData={promotionsData}
                            slug={row.slug}
                            isHidden={isHidden}
                            handleStatusShow={handleStatusShow}
                            isActive={row.isActive}
                            navigate={navigate}
                            handleDeletePromotions={handleDeletePromotions}
                          />
                        </td>
                      );

                    default:
                      return <td key={cIdx}>--</td>;
                  }
                })}
              </tr>
            ))}

            {!loading && (!promotionsData || promotionsData.length === 0) && (
              <tr>
                <td colSpan={visibleColumns.length} className="text-danger text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>


        </Table>
        {promotionsData && promotionsData.length > 0 && !loading && (
          <PaginationComponent
            page={promotionsData?.count < page ? setPage(1) : page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            paginationRef={paginationRef}
            countText={"Total Promotions :  "}
            totalCount={totalCount}
            showTotalCount={true}
          />
        )}
      </div> : <TableErrorMessage />}

      <ConfirmationModal
        setShow={setStatusShow}
        show={statusShow}
        handleYes={handleYes}
        active={status}
        name={name}
      />

      <ImageModal show={imageModal?.isOpen} setShow={() => setImageModal({ isOpen: false, url: "" })} imageUrl={imageModal?.url} altText="Preview" />


    </>
  )
}
